import { RootState } from 'store';
import { useSelector } from 'react-redux';
import {
  checkIsLoading,
  checkIsLoadingDone
} from 'common/utils/checkLoading';

import { DRIVERS_STATE } from '../../constants';

export const useDriverFilteredFuelAssignments = () => {
  const driverFilteredFuelAssignments = useSelector((state: RootState) => state[DRIVERS_STATE].filteredFuelAssignments.data);
  return driverFilteredFuelAssignments;
};

export const useDriverFilteredFuelAssignmentsPaging = () => {
  const driverFilteredFuelAssignmentsPaging = useSelector((state: RootState) => state[DRIVERS_STATE].filteredFuelAssignments.paging);
  return driverFilteredFuelAssignmentsPaging;
};

export const useDriverFilteredFuelAssignmentsFilter = () => {
  const driverFilteredFuelAssignmentsFilter = useSelector((state: RootState) => state[DRIVERS_STATE].filteredFuelAssignments.filter);
  return driverFilteredFuelAssignmentsFilter;
};

const useDriverFilteredFuelAssignmentsLoadingStatus = () => {
  const driverFilteredFuelAssignmentsLoadingStatus = useSelector((state: RootState) => state[DRIVERS_STATE].filteredFuelAssignments.loadingStatus);
  return driverFilteredFuelAssignmentsLoadingStatus;
};

export const useIsDriverFilteredFuelAssignmentsLoading = () => {
  const driverFilteredFuelAssignmentsLoadingStatus = useDriverFilteredFuelAssignmentsLoadingStatus();
  return checkIsLoading(driverFilteredFuelAssignmentsLoadingStatus);
};

export const useIsDriverFilteredFuelAssignmentsDone = () => {
  const driverFilteredFuelAssignmentsLoadingStatus = useDriverFilteredFuelAssignmentsLoadingStatus();
  return checkIsLoadingDone(driverFilteredFuelAssignmentsLoadingStatus);
};
